import Video from '../../interfaces/video';

export interface OnBoardingState {
  readonly videos: Video[];
  readonly error: boolean;
  readonly loading: boolean;
}

export enum ActionTypes {
  FETCH = 'onboarding/FETCH',
  FETCH_SUCCESS = 'onboarding/FETCH_SUCCESS',
  FETCH_ERROR = 'onboarding/FETCH_ERROR',
  RESET_STATE = 'onboarding/RESET_STATE',
}

export interface FetchOnBoardingAction {
  type: ActionTypes.FETCH;
}

export interface FetchOnBoardingSuccessAction {
  type: ActionTypes.FETCH_SUCCESS;
  videos: Video[];
}

export interface ResetStateAction {
  type: ActionTypes.RESET_STATE;
}

export interface FetchOnBoardingErrorAction {
  type: ActionTypes.FETCH_ERROR;
}

export type Action =
  | FetchOnBoardingAction
  | FetchOnBoardingSuccessAction
  | FetchOnBoardingErrorAction
  | ResetStateAction;
